import { SettingsReducerState, SettingsTabs } from './types';

export const initialState: SettingsReducerState = {
  activeTab: SettingsTabs.General,
};
